/* eslint react-hooks/rules-of-hooks: "warn" */
import { IUserInfoParams, useUserInfoModel } from '@/store/models/user-info-model';

export const userGetUserInfo = () => {
    return useUserInfoModel((actions) => actions.getUserInfo);
};

export const useUserInfoHelper = () => {
    const setUserInfo = useUserInfoModel((actions) => actions.setUserInfo);
    const userInfo = useUserInfoModel((state) => state.userInfo) || undefined;

    const showUserInfo = () => {
        return userInfo;
    };

    const onSetUserInfo = (userInfo: IUserInfoParams) => {
        setUserInfo(userInfo);
    };

    return {
        showUserInfo,
        onSetUserInfo,
        setUserInfo,
        userInfo,
    };
};
